/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Operator connecting FilterRows
 * @export
 */
export const FilterRowOperatorConstants = {
    AND: 'AND',
    OR: 'OR'
} as const;
export type FilterRowOperatorConstants = typeof FilterRowOperatorConstants[keyof typeof FilterRowOperatorConstants];


export function FilterRowOperatorConstantsFromJSON(json: any): FilterRowOperatorConstants {
    return FilterRowOperatorConstantsFromJSONTyped(json, false);
}

export function FilterRowOperatorConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterRowOperatorConstants {
    return json as FilterRowOperatorConstants;
}

export function FilterRowOperatorConstantsToJSON(value?: FilterRowOperatorConstants | null): any {
    return value as any;
}

